// components/FAQSection/FAQSection.jsx
import React, { useState, useRef, useEffect } from "react";
import "./FAQSection.css";
import { faqData } from "../../data/faqData";

// Fades each FAQ item up with a staggered delay
// Fades each FAQ item up with a staggered delay
const RevealItem = ({ children, index }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) { setVisible(true); observer.unobserve(el); }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.unobserve(el);
  }, []);

  const delayClass = `reveal-delay-${Math.min(index + 1, 6)}`;

  return (
    <div
      ref={ref}
      className={`reveal ${delayClass}${visible ? " is-visible" : ""}`}
    >
      {children}
    </div>
  );
};



const FAQSection = () => {
  const [activeTab, setActiveTab] = useState("student");
  const [openIndex, setOpenIndex] = useState(null);
  const [showAll, setShowAll] = useState(false);
    const [headingVisible, setHeadingVisible] = useState(false);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  
 // Section heading reveal
  const headingRef = useRef(null);

  useEffect(() => {
    const el = headingRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setHeadingVisible(true); observer.unobserve(el); } },
      { threshold: 0.2 }
    );
    observer.observe(el);
    return () => observer.unobserve(el);
  }, []);


  const visibleFAQs = showAll
    ? faqData[activeTab]
    : faqData[activeTab].slice(0, 5);

  return (
    <section className="faq-section">
      <div className="faq-container">
        {/* Left */}
        <div 
        // className="faq-left"
         ref={headingRef}
          className={`faq-left reveal${headingVisible ? " is-visible" : ""}`}

        >
          <div className="faq-icon">❓</div>
          <h2>Frequently Asked Questions</h2>
          <p>Select a category to explore answers related to your role.</p>

          {/* Category Buttons */}
          <div className="faq-tabs">
            <button
              className={`faq-tab-btn ${activeTab === "student" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("student");
                setOpenIndex(null);
                setShowAll(false);
              }}
            >
              🎓 Student
            </button>

            <button
              className={`faq-tab-btn ${activeTab === "tutor" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("tutor");
                setOpenIndex(null);
                setShowAll(false);
              }}
            >
              🏫 Tutor / Centre
            </button>
          </div>
        </div>

        {/* Right */}
        <div className="faq-right">
          {visibleFAQs.map((item, i) => (
             <RevealItem key={i} index={i}>

            <div key={i} className="faq-item">
              <div
                className="faq-question"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h4>{item.q}</h4>
                <span className={`faq-toggle ${openIndex === i ? "open" : ""}`}>
                  {openIndex === i ? "−" : "+"}
                </span>
              </div>
              {openIndex === i && (
                <div className="faq-answer">{item.a}</div>
              )}
            </div>
             </RevealItem>
          ))}

          {/* More Button */}
          {faqData[activeTab].length > 5 && (
            <div className="faq-more-wrapper">
              <button
                className="faq-more-btn"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? "Show Less" : "See More FAQs"}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
